"use strict";
exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = void 0;
var tslib_1 = require("tslib");
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var Icon_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Icon"));
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var BaseArrow = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: background-color 0.2s;\n  background: transparent;\n  font-size: 0;\n  border-radius: 50%;\n  padding: ", "px;\n  cursor: pointer;\n  ", "\n    :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"], ["\n  position: absolute;\n  z-index: 1;\n  top: 50%;\n  transform: translateY(-50%);\n  transition: background-color 0.2s;\n  background: transparent;\n  font-size: 0;\n  border-radius: 50%;\n  padding: ", "px;\n  cursor: pointer;\n  ",
    "\n    :hover {\n    background: rgba(255, 255, 255, 0.3);\n  }\n"])), function (_a) {
    var containerWidth = _a.containerWidth;
    return (containerWidth > 800 ? 30 : 15);
}, function (_a) {
    var next = _a.next;
    return next
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n            right: 1%;\n          "], ["\n            right: 1%;\n          "]))) : styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n            left: 1%;\n          "], ["\n            left: 1%;\n          "])));
});
exports.PrevArrow = function (_a) {
    var onClick = _a.onClick, containerWidth = _a.containerWidth;
    return (react_1["default"].createElement(BaseArrow, { onClick: onClick, containerWidth: containerWidth },
        react_1["default"].createElement(Icon_1["default"], { name: "arrow-left", size: containerWidth > 800 ? 'xl' : 'm' })));
};
exports.PrevArrow.propTypes = {
    onClick: prop_types_1["default"].func,
    containerWidth: prop_types_1["default"].number.isRequired
};
exports.PrevArrow.defaultProps = {
    onClick: function () {
        //
    }
};
exports.NextArrow = function (_a) {
    var onClick = _a.onClick, containerWidth = _a.containerWidth;
    return (react_1["default"].createElement(BaseArrow, { next: true, onClick: onClick },
        react_1["default"].createElement(Icon_1["default"], { name: "arrow-right", size: containerWidth > 800 ? 'xl' : 'm' })));
};
exports.NextArrow.propTypes = exports.PrevArrow.propTypes;
exports.NextArrow.defaultProps = exports.PrevArrow.defaultProps;
var templateObject_1, templateObject_2, templateObject_3;
